import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function createNbPlayerBtn(k, x, y, playerNb, onClickCallback) {
    let preventExtraClick = false;

    const btn = k.add([
        k.sprite("SmallRedSquareButton_Regular"),
        k.pos(x, y),
        k.anchor("center"),
        k.area(),
        k.z(6),
        k.scale(0.8),
        UI_TAGS.NB_PLAYER_BUTTON
    ]);

    const txt = btn.add([
        k.text(playerNb + "P", {size: 30}),
        k.pos(0, 0),
        k.anchor("center"),
        k.z(7),
    ]);

    btn.onHover(() => {
        if (preventExtraClick) return;
        k.tween(btn.scale.x, 0.85, 0.1, v => btn.scale = k.vec2(v), k.easings.easeOutQuad);
    });

    btn.onHoverEnd(() => {
        if (preventExtraClick) return;
        k.tween(btn.scale.x, 0.8, 0.1, v => btn.scale = k.vec2(v), k.easings.easeOutQuad);
    });

    btn.onClick(() => {
        if (preventExtraClick) return;
        preventExtraClick = true;

        btn.use(k.sprite("SmallRedSquareButton_Pressed"));
        txt.pos = k.vec2(0, 10);

        k.play("sheep", {volume: 0.3, speed: 1, loop: false});

        k.wait(0.2, () => {
            onClickCallback(playerNb);

            btn.use(k.sprite("SmallRedSquareButton_Regular"));
            txt.pos = k.vec2(0, 0);
        });
    });

    return btn;
}